export default "__VITE_ASSET__CjQlz6a3__"